import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { useField } from 'formik';
import React__default from 'react';
import '../input/Input.js';
import '../input/InputGroup.js';
import '../input/InputElement.js';
import '../input/PasswordInput.js';
import '../input/MobileInput.js';
import '../input/SearchInput.js';
import '../input/CopyInput.js';
import { ErrorMessage } from '../input/ErrorMessage.js';
import '../input/Field.js';
import '../input/PasswordField.js';
import '../input/MobileField.js';
import { Select } from './Select.js';
var GenericSelectField = function GenericSelectField(_a, ref) {
  var shouldShowErrorMessage = _a.shouldShowErrorMessage,
    onChange = _a.onChange,
    props = __rest(_a, ["shouldShowErrorMessage", "onChange"]);
  var _b = useField(props),
    field = _b[0],
    meta = _b[1],
    helpers = _b[2];
  var options = props.options,
    onBlur = props.onBlur;
  var value = field.value;
  var touched = meta.touched,
    error = meta.error;
  var setValue = helpers.setValue,
    setTouched = helpers.setTouched;
  var handleChange = React__default.useCallback(function (val) {
    setValue(val === null || val === void 0 ? void 0 : val.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(val === null || val === void 0 ? void 0 : val.value);
  }, [onChange, setValue]);
  var handleBlur = React__default.useCallback(function (e) {
    setTouched(true);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }, [onBlur, setTouched]);
  return React__default.createElement("div", null, React__default.createElement(Select, __assign({}, field, {
    isInvalid: Boolean(touched && error)
  }, props, {
    onChange: handleChange,
    onBlur: handleBlur,
    value: (options === null || options === void 0 ? void 0 : options.find(function (x) {
      return x.value === value;
    })) || null,
    defaultValue: (options === null || options === void 0 ? void 0 : options.find(function (x) {
      return x.value === value;
    })) || null,
    blurInputOnSelect: false,
    ref: ref
  })), shouldShowErrorMessage && React__default.createElement(ErrorMessage, {
    isVisible: Boolean(touched && error)
  }, error));
};
var SelectField = React__default.forwardRef(GenericSelectField);
export { SelectField };